import React, {useEffect, useRef, useState} from 'react';
import {useUser} from "./auth/UserContext";
import Auth from "./auth";
import {SidebarProvider, useSidebar} from "./SidebarContext";
import Sidebar from "./Sidebar";
import {Sidebar as PrimeSidebar} from "primereact/sidebar";
import config from "./config";
import {isDesktop} from "./utils/functions";
import Menubar from "./Menubar";
import {Menu} from "primereact/menu";
import Config from "./config";
import * as Icons from "./icons";
import "./App.css";
import {Route, Routes} from "react-router-dom";
import NotFound from "./pages/NotFound";
import Case from "./pages/case";
import Create from "./pages/case/create";
import Note from "./pages/case/note";

function Toolbar({setVisibleSidebar}) {
    const user = useUser();
    const menu = useRef();
    const sidebar = useSidebar();
    const userMenuItems = [
        {
            label:Config.glossary.userID,
            value:"13245789"
        },
        {
            label:Config.glossary.userManagement,
            command:()=>{}

        },
        {
            label:Config.glossary.signOut,
            command:()=>{user.logout()}
        },
    ]
    return(
        <div className="flex align-items-center w-full h-4rem bg-primary">
            <div className="flex flex-1 align-items-center">
                <span className="pi pi-bars p-3" onClick={()=>{setVisibleSidebar(true)}}/>
                <div className="flex flex-column gap-1">
                    <span className="font-bold text-sm">{Config.glossary[sidebar.getSelectedItem().title]?Config.glossary[sidebar.getSelectedItem().title].title:sidebar.getSelectedItem().title}</span>
                    <span className="text-primary-200 text-xs">{Config.glossary[sidebar.getSelectedItem().title]?Config.glossary[sidebar.getSelectedItem().title].description:""}</span>
                </div>
            </div>
            <span className="pi pi-ellipsis-v p-3" onClick={(event) => menu.current.toggle(event)}/>
            <Menu className={config.glossary.dir} model={userMenuItems} popup ref={menu} />
        </div>
    )
}

function App() {
    const [visibleSidebar, setVisibleSidebar] = useState(false);
    const user = useUser();
    // if (user.state.userData && user.state.userData.companies===undefined)user.logout();



    return(
        <div className={`h-screen w-screen ${config.glossary.dir} `}>
            <SidebarProvider>
                {
                    user.state.userData?(
                        <div className="flex flex-column h-full">
                            {
                                !isDesktop() && (
                                    <div className="flex lg:hidden shadow-2">
                                        <Toolbar setVisibleSidebar={setVisibleSidebar}/>
                                        <PrimeSidebar dir={config.glossary.dir} showCloseIcon={false} position={`${config.glossary.dir==="rtl"?"right":"left"}`} visible={visibleSidebar} onHide={()=>{setVisibleSidebar(false)}}>
                                            <Sidebar/>
                                        </PrimeSidebar>
                                    </div>
                                )
                            }
                            <div className="flex flex-1 overflow-hidden">
                                <div className="p-4 w-24rem hidden lg:block ">
                                    <div className="border-round-2xl shadow-2 bg-white h-full">
                                        <Sidebar/>
                                    </div>
                                </div>
                                <div className={`flex-1 overflow-hidden flex flex-column ${isDesktop() && 'p-4'} ${isDesktop() && config.glossary.dir==="rtl"?"pr-0":"pl-0"}`}>
                                    {isDesktop()&&(<Menubar/>)}
                                    <div className="flex-1">
                                        <div className="h-full w-full lg:pt-4 pr-1 ">
                                            <div className="lg:border-round-2xl lg:shadow-2 h-full w-full">
                                                {/*Switch the pages hear */}
                                                <Routes>
                                                    <Route path="/" element={<Case/>}/>
                                                    <Route path="/case" element={<Case/>}/>
                                                    <Route path="/case/create" element={<Create/>}/>
                                                    <Route path="/case/note/:id" element={<Note/>}/>
                                                    <Route path="*" element={<NotFound/>}/>
                                                </Routes>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ):(
                        <div className="h-full">
                            <Auth/>
                        </div>
                    )
                }
            </SidebarProvider>
        </div>
    )
}

export default App;